import { render, staticRenderFns } from "./AlertBanner.vue?vue&type=template&id=309906b8&lang=pug&"
import script from "./AlertBanner.vue?vue&type=script&lang=js&"
export * from "./AlertBanner.vue?vue&type=script&lang=js&"
import style0 from "./AlertBanner.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports